import styled from 'styled-components';
import {Menu} from '@/components/Menu';
import {Typography} from '@/components/Typography';
import {FlexCenter} from '@/styled-components';
import {interceptProps} from '@/styled-components/utils';
import {palette} from '@/styles/palette';

export const Dropdown = styled(Menu)`
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 4px;
  box-shadow: 0px 4px 10px 0px #00000026;
`;

export const ButtonItem = styled(FlexCenter).withConfig({
  shouldForwardProp: interceptProps(['active', 'disabled']),
})<{
  active?: boolean;
  disabled?: boolean;
}>`
  width: 64px;
  height: 48px;
  border-radius: 5px;
  flex-direction: column;
  font-weight: 500;
  cursor: pointer;
  gap: 2px;
  color: ${palette.gray600};
  ${({active}) =>
    active &&
    `
    box-shadow: 0px 4px 10px 0px #00000026;
      background-color: ${palette.white};
      color: ${palette.textPrimary};
      font-weight: 700;
    `}
`;

export const ButtonContainer = styled.div`
  position: relative;
`;

export const AddrBadge = styled(Typography).attrs({
  as: 'div',
  variant: 'medium10',
})`
  padding: 4px;
  margin-right: 4px;
  color: ${palette.textSecondary};
  border: solid 1px ${palette.gray200};
  flex-shrink: 0;
`;
